
import React, { useState } from 'react';
import {
    Card, CardBody, Row, Col, Form, FormGroup, Label, Input, Button, Table, Badge, Alert,
    UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonGroup
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';


const Guardrails = ({ channelDetails, saveIntegration }) => {
    // Configurable rules state
    const [confidenceThreshold, setConfidenceThreshold] = useState(channelDetails?.guardrails?.confidence || 80);


    // Simulated email input and evaluation state (dynamic list)
    const [emailInputList, setEmailInputList] = useState(channelDetails?.guardrails?.emails || [
    ]);
    const addNewEmailInput = () => {
        setEmailInputList([
            ...emailInputList,
            { id: Date.now() + Math.random(), key: '', content: '' }
        ]);
    };
    const handleEmailInputChange = (idx, updated) => {
        setEmailInputList(emailInputList.map((item, i) => i === idx ? { ...item, ...updated } : item));
    };
    const removeEmailInput = (idx) => {
        setEmailInputList(emailInputList.filter((_, i) => i !== idx));
    };


    const updateEmailInputResult = (idx, detectedIntent, result) => {
        setEmailInputList(emailInputList.map((item, i) => i === idx ? { ...item, detectedIntent, result } : item));
    };

    // Forward rules (dynamic input list) - forward matching emails/domains to another address
    const [forwardRules, setForwardRules] = useState(channelDetails?.guardrails?.forwardRules || []);
    const addNewForwardRule = () => {
        setForwardRules([
            ...forwardRules,
            ''
        ]);
    };
    const handleForwardRuleChange = (index, updated) => {
        setForwardRules(forwardRules.map((item, i) => i === index ? updated : item));
    };
    const removeForwardRule = (index) => {
        setForwardRules(forwardRules.filter((_, i) => i !== index));
    };

    // Add/delete row handlers for key-Based Restrictions (dynamic input list)
    const [newSenderRuleList, setNewSenderRuleList] = useState(channelDetails?.guardrails?.domains || [
    ]);
    const addNewSenderRuleInput = () => {
        setNewSenderRuleList([
            ...newSenderRuleList,
            { id: Date.now() + Math.random(), key: '', value: 'NoResponse' }
        ]);
    };
    const handleNewSenderRuleChange = (idx, updatedRule) => {
        setNewSenderRuleList(newSenderRuleList.map((rule, i) => i === idx ? updatedRule : rule));
    };
    const removeNewSenderRule = (idx) => {
        setNewSenderRuleList(newSenderRuleList.filter((_, i) => i !== idx));
    };


    // Add/delete row handlers for key Checks (dynamic input list)
    const [newIntentRuleList, setNewIntentRuleList] = useState(channelDetails?.guardrails?.contents || [
    ]);
    const addNewIntentRuleInput = () => {
        setNewIntentRuleList([
            ...newIntentRuleList,
            { id: Date.now() + Math.random(), key: '', value: 'NoResponse' }
        ]);
    };
    const handleNewIntentRuleChange = (idx, updatedRule) => {
        setNewIntentRuleList(newIntentRuleList.map((rule, i) => i === idx ? updatedRule : rule));
    };
    const removeNewIntentRule = (idx) => {
        setNewIntentRuleList(newIntentRuleList.filter((_, i) => i !== idx));
    };

    const handleSave = () => {
        let guardrails = { confidence: confidenceThreshold, emails: emailInputList, domains: newSenderRuleList, contents: newIntentRuleList, forwardRules };
        channelDetails.guardrails = guardrails;
        saveIntegration({ channelDetails: channelDetails });
    }

    return (
        <Card>
            <CardBody>
                <div className="text-center mb-2">
                    <h5 className="mb-2">Email Response Guardrails</h5>
                    {/* <p className="mb-2">
                        Configure rules to control when AI-generated email responses are sent, drafted, or blocked.
                    </p> */}
                    <p className="mb-2">
                        All rules are evaluated in order: <b>Sender Based Restrictions → Content & Intent Checks → Confidence Accuracy</b>.
                    </p>
                </div>
                <Separator className="mb-3" />
                <h3></h3>


                <Row className="mb-3">
                    <Col md={12}>
                        <h5 className="mb-2">Sender Based Restrictions</h5>
                        <p className="mb-2">Do not respond to emails from specific domains</p>
                        {/* Dynamic list of new key rule inputs */}
                        {newSenderRuleList.map((rule, idx) => (
                            <Row key={rule.id} className="mb-2 gx-2">
                                <Col xs={6} className="">
                                    <FormGroup>
                                        <Input key="text" placeholder="Domain" value={rule.key} onChange={e => handleNewSenderRuleChange(idx, { ...rule, key: e.target.value })} style={{ width: '100%' }} />
                                    </FormGroup>
                                </Col>
                                <Col xs={3} className="">
                                    <FormGroup>
                                        <Input
                                            type="select"
                                            value={rule.value}
                                            onChange={e => handleNewSenderRuleChange(idx, { ...rule, value: e.target.value })}
                                            style={{ width: '100%' }}
                                        >
                                            <option value="NoResponse">No Response</option>
                                            <option value="AutoResponse">Auto Response</option>
                                            <option value="Draft">Generate Draft</option>
                                            <option value="Forward">Forward Email</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col xs={2} className=" d-flex align-items-center" style={{ marginTop: '-0.75rem' }}>
                                    <Button color="danger" outline size="xs" key="button" onClick={() => removeNewSenderRule(idx)}>X</Button>
                                </Col>

                            </Row>
                        ))}
                        <Button color="primary" outline size="xs" key="button" className="mb-2" onClick={addNewSenderRuleInput}>+ Add Domain</Button>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col md={12}>
                        <h5 className="mb-2">Do not respond to emails from specific email addresses</h5>

                        {emailInputList.map((item, idx) => (
                            <Row key={item.id} className="mb-2 gx-2">
                                <Col xs={6} className="">
                                    <FormGroup>
                                        <Input
                                            id={`key-${item.id}`}
                                            key="email"
                                            placeholder="Email (e.g. user@domain.com)"
                                            required
                                            value={item.key}
                                            onChange={e => handleEmailInputChange(idx, { key: e.target.value })}
                                            style={{ width: '100%' }}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs={3} className="">
                                    <FormGroup>
                                        <Input
                                            type="select"
                                            value={item.value}
                                            onChange={e => handleEmailInputChange(idx, { ...item, value: e.target.value })}
                                            style={{ width: '100%' }}
                                        >
                                            <option value="NoResponse">No Response</option>
                                            <option value="AutoResponse">Auto Response</option>
                                            <option value="Draft">Generate Draft</option>
                                            <option value="Forward">Forward Email</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col xs={2} className=" d-flex align-items-center" style={{ marginTop: '-0.75rem' }}>
                                    <Button color="danger" outline size="xs" key="button" className="mb-2" onClick={() => removeEmailInput(idx)} disabled={emailInputList.length === 1}>X</Button>
                                </Col>

                            </Row>
                        ))}
                        <Button color="primary" outline size="xs" key="button" className="mb-2" onClick={addNewEmailInput}>+ Add Email</Button>
                    </Col>
                </Row>

                <Separator className="mb-3" />
                <Row className="mb-3">
                    <Col md={12}>
                        <h5 className="mb-2">Content & Intent Checks</h5>
                        <p className='mb-2'>Do not respond if email contains the following intents</p>
                        {/* Dynamic list of new key rule inputs */}
                        {newIntentRuleList.map((rule, idx) => (
                            <Row key={rule.id} className="mb-2 gx-2">
                                <Col xs={6} className="">
                                    <FormGroup>
                                        <Input key="text" placeholder="Intent (e.g. Legal)" value={rule.key} onChange={e => handleNewIntentRuleChange(idx, { ...rule, key: e.target.value })} style={{ width: '100%' }} />
                                    </FormGroup>
                                </Col>
                                <Col xs={3} className="">
                                    <FormGroup>
                                        <Input
                                            type="select"
                                            value={rule.value}
                                            onChange={e => handleNewIntentRuleChange(idx, { ...rule, value: e.target.value })}
                                            style={{ width: '100%' }}
                                        >
                                            <option value="NoResponse">No Response</option>
                                            <option value="AutoResponse">Auto Response</option>
                                            <option value="Draft">Generate Draft</option>
                                            <option value="Forward">Forward Email</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col xs={2} className=" d-flex align-items-center">
                                    <Button color="danger" outline size="xs" key="button" onClick={() => removeNewIntentRule(idx)}>X</Button>
                                </Col>
                            </Row>
                        ))}
                        <Button color="primary" outline size="xs" key="button" className="mb-2" onClick={addNewIntentRuleInput}>+ Add Intent</Button>

                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={12}>
                        <h5 className="mb-2">Forward Rules</h5>
                        <p className="mb-2">Forward matching emails or domains to another address</p>
                        {forwardRules.map((item, index) => (
                            <Row key={index} className="mb-2 gx-2">
                                <Col xs={9} className="">
                                    <FormGroup>
                                        <Input
                                            placeholder="Email"
                                            value={item}
                                            onChange={e => handleForwardRuleChange(index, e.target.value)}
                                            style={{ width: '100%' }}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs={2} className=" d-flex align-items-center" style={{ marginTop: '-0.75rem' }}>
                                    <Button color="danger" outline size="xs" key="button" onClick={() => removeForwardRule(index)}>X</Button>
                                </Col>
                            </Row>
                        ))}
                        <Button color="primary" outline size="xs" key="button" className="mb-2" onClick={addNewForwardRule}>+ Add Forward Rule</Button>
                    </Col>
                </Row>
                <Separator className="mb-3" />
                <Row className="mb-3">
                    <Col md={12}>
                        <h5 className="mb-2">Confidence Accuracy</h5>
                        <FormGroup>
                            <Label>If confidence score less then a certain %age DO NOT generate or send response</Label>
                            <Input
                                key="number"
                                min={0}
                                max={100}
                                value={confidenceThreshold}
                                onChange={e => setConfidenceThreshold(Number(e.target.value))}
                                style={{ width: '50%' }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Separator className="my-2" />
                <Colxx md="12" className="text-center">
                    <Button
                        color="primary"
                        size="xs"
                        outline
                        onClick={handleSave}
                    >
                        Save
                    </Button>
                </Colxx>
            </CardBody>
        </Card>
    );
};

export default Guardrails;
